import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/facebookPixel';
import { isNativePlatform } from '@/utils/nativePlugins';

/**
 * Component that tracks page views with Facebook Pixel on route changes
 * Should be placed inside BrowserRouter
 */
const FacebookPixelPageView = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip tracking on native platforms (ATT compliance)
    if (isNativePlatform()) return;
    trackPageView();
  }, [location.pathname]);

  return null;
};

export default FacebookPixelPageView;
